/*SYSTEM IMPORTS*/
import React from 'react'
import Img from "components/Img";

import './style'
import './media'

/*Ui*/
import Cont from 'components/ui/Cont'
import ListDoctorAdvantages, { DoctorAdvantageItem } from 'components/ui/ListDoctorAdvantages'

/*HELPERS*/
import {Helpers} from "api";
import AppCore from 'cores/AppCore'

const ContAdvantages = ({ id, value:{ image = "",  advantages = [] } }) => {

    const halfLength = Math.ceil(advantages.length / 2)

    return (
        <>
            {(advantages.length > 1 || (advantages.length == 1 && advantages[0] && advantages[0].value != "")) &&
                <Cont id={`block-${id}`} className="cont-doctor-advantages">
                    <h2>
                        { AppCore.Interfaces.t( "DoctorLanding.Ui.ContDoctorAdvantages.Index.Title" ) }
                    </h2>
                    <div className="cont-doctor__flex-wrapp">
                        <ListDoctorAdvantages className="left">
                            {advantages.limit(halfLength).map( item => (
                                <DoctorAdvantageItem
                                    key={item.id}
                                    number={item.id}
                                    value={item.value}
                                >
                                    {item.value}
                                </DoctorAdvantageItem>
                            ))}
                        </ListDoctorAdvantages>

                        <div className="round-photo">
                            <Img src={`${Helpers.GetImage(image, "253_251")}`} externals div/>
                        </div>

                        <ListDoctorAdvantages className="right">
                            {advantages.offset(halfLength).map( item => (
                                <DoctorAdvantageItem
                                    key={item.id}
                                    number={item.id}
                                    value={item.value}
                                >
                                    {item.value}
                                </DoctorAdvantageItem>
                            ))}
                        </ListDoctorAdvantages>
                    </div>
                </Cont>
            }
        </>

    )
}

export default ContAdvantages